var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfeedbackSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56812 8.78294C2.56812 5.16336 5.56448 2.16699 9.18407 2.16699H32.6188C36.2384 2.16699 39.2348 5.16336 39.2348 8.78294V32.2177C39.2348 35.8373 36.2384 38.8337 32.6188 38.8337H9.18407C5.56448 38.8337 2.56812 35.8373 2.56812 32.2177V8.78294ZM19.7741 10.2422C20.3968 9.61963 21.4061 9.61963 22.0288 10.2422L26.5939 14.8074C27.2164 15.43 27.2164 16.4394 26.5939 17.062C25.9714 17.6845 24.962 17.6845 24.3395 17.062L22.4956 15.2182V26.5877C22.4956 27.4682 21.7819 28.1818 20.9014 28.1818C20.021 28.1818 19.3073 27.4682 19.3073 26.5877V15.2182L17.4635 17.062C16.8409 17.6845 15.8315 17.6845 15.209 17.062C14.5864 16.4394 14.5864 15.43 15.209 14.8074L19.7741 10.2422ZM10.2493 31.0807C9.36883 31.0807 8.65508 31.7943 8.65508 32.6748C8.65508 33.5553 9.36883 34.269 10.2493 34.269H31.5536C32.4341 34.269 33.1478 33.5553 33.1478 32.6748C33.1478 31.7943 32.4341 31.0807 31.5536 31.0807H10.2493Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfeedbackSubmitted);
export default __webpack_public_path__ + "static/media/ifeedback_submitted.c79c2a54dd34015ac8f47e882a31ab77.svg";
export { ForwardRef as ReactComponent };